// BAIRROS DAS CIDADES MARCADAS — busca da home dos modelos novos (utils/buscaMultiSelecao).
//
// Recebe o texto de ids de cidade do useHeroSearch ("12,7") e devolve os bairros para marcar:
//  - 1 cidade: a lista de sempre da query `bairros` (formatSelects) — a URL leva a cidade no caminho;
//  - 2+ cidades: a união das listas (`uniaoBairrosDasCidades`: nome repetido ganha "(CIDADE)"), o
//    MESMO rótulo que a /imoveis monta ao ler `?cidades=` + bairros do caminho na volta.
// Usado pelo painel "Busca avançada" (BuscaAvancadaAurora) e pelo campo Bairro do Atelier.
import { useEffect, useState } from 'react';
import { district } from '../../../services/selectors';
import { idsDoTexto, uniaoBairrosDasCidades } from '../../../utils/buscaMultiSelecao';
import { formatSelects } from '../../../utils/FunctionsGlobals';

export type OpcaoBairro = { label: string; value: any };

export function useBairrosDasCidades(
    cidades: string,
    origin: any,
    codsite: any,
    allCities?: Array<{ label?: string; value?: any }> | null
) {
    const [bairros, setBairros] = useState<OpcaoBairro[]>([]);
    const [carregando, setCarregando] = useState(false);
    const chave = idsDoTexto(cidades)
        .filter((id) => Number(id) > 0)
        .join(',');

    useEffect(() => {
        if (!chave) {
            setBairros([]);
            setCarregando(false);
            return undefined;
        }
        let vivo = true;
        const ids = chave.split(',').map(Number);
        setCarregando(true);
        Promise.all(ids.map((id) => district(id, origin, codsite).catch(() => null))).then((respostas: any[]) => {
            if (!vivo) return;
            setBairros(ids.length === 1 ? formatSelects(respostas[0]?.bairros) || [] : uniaoBairrosDasCidades(respostas, allCities));
            setCarregando(false);
        });
        return () => {
            vivo = false;
        };
        // allCities fora das deps: só dá nome à cidade dos bairros repetidos e não muda depois do SSR
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chave, origin, codsite]);

    return { bairros, carregando, idsCidades: chave ? chave.split(',') : [] };
}
